import { ChangeDetectorRef, Component, Injectable, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatHorizontalStepper } from '@angular/material/stepper';
//import { RutValidator } from 'ng9-rut';
//import { RutValidator } from 'ng2-rut';
import { ObservableInspService } from 'src/app/services/observable_insp';
import { UserService } from 'src/app/services/user.service';
import { RegistroComponent } from '../../../home/registro/registro.component';
import { rutClean } from 'rut-helpers';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material';

declare const swal: any;
@Injectable()
@Component({
  selector: 'app-solicitante-insp',
  templateUrl: './solicitante-insp.component.html',
  styleUrls: ['./solicitante-insp.component.css']
})
export class SolicitanteInspComponent implements OnInit {
  sig: boolean;
  firstFormGroup: FormGroup;
  modificando = false;
  primerPaso = false;
  rut_encontrado = false;
  info_rut;
  continuar = false;
  emailValido = false;
  rutSolicitante;
  celularValido = false;
  primerPaso_mod = false;

  btnBuscaRut = false
  entrevalidar = false



  // private rutValidator: RutValidator,
  constructor(private dialog: MatDialog, private _formBuilder: FormBuilder, private _userService: UserService, private _changeDetector: ChangeDetectorRef, private observableService: ObservableInspService, private spinner: NgxSpinnerService, private _router: Router
  ) {


    this.firstFormGroup = this._formBuilder.group({
      rut: ["", [Validators.required]],
      dv: ["", [Validators.required]],
      mod_solicitante: this._formBuilder.group({
        nombre: ["", [Validators.required]],
        apellido_p: [""],
        apellido_m: [""],
        calle: ["", [Validators.required]],
        num: ["", [Validators.required]],
        complemento: [""],
        telefono: [""],
        cel: ["", [Validators.required]],
        ciudad: [""],
        comuna: [""],
        email: ["", [Validators.required, Validators.email]],
      }),
    });


    if (sessionStorage.getItem('identity-domCloud')) {
      let identityData = this._userService.getIdentity();
      this.firstFormGroup.controls['rut'].setValue(identityData.rut);
      this.firstFormGroup.controls['dv'].setValue(identityData.dv);
      this.validaRut()
      this.searchUser()
    } else {
      this._router.navigate(['/inicio'])
      swal({
        type: 'warning',
        text: "Para acceder a estos servicios, deberá iniciar sesión con su clave de sistema o su clave única.",
        showConfirmButton: true,
        confirmButtonText: 'Aceptar',
        allowOutsideClick: false
      })
    }
  }

  ngOnInit(): void {
  }




  parametros(va) {
    //console.log('valo ', va);
    this.firstFormGroup.valid;

  }

  validaRut() {

    var rutSinPuntos = this.firstFormGroup.controls.rut.value + "-" + this.firstFormGroup.controls.dv.value;

    var resultado = comprueba(rutSinPuntos)

    /* this.firstFormGroup = this._formBuilder.group({
      rutFull: [rutSinPuntos, [this.rutValidator]]
    });
    */
    function comprueba(rutCompleto) {
      if (!/^[0-9]+[-|‐]{1}[0-9kK]{1}$/.test(rutCompleto))
        return false;
      var tmp = rutCompleto.split('-');
      var digv = tmp[1];
      var rut = tmp[0];
      if (digv == 'K') digv = 'k';
      return (digitoverificador(rut) == digv);
    }

    function digitoverificador(T) {
      var M = 0, S = 1;
      for (; T; T = Math.floor(T / 10))
        S = (S + T % 10 * (9 - M++ % 6)) % 11;
      return S ? S - 1 : 'k';
    }


    //console.log('va  vAva  ', resultado);
    if (resultado == true) {
      this.firstFormGroup.valid;
      this.btnBuscaRut = true
    } else {

      this.btnBuscaRut = false
    }
    //this.firstFormGroup.valid;
    this.entrevalidar = true
    console.log("entre en validar ", this.entrevalidar)

  }




  buscar_info_sol() {
    var rutSinPuntos = this.firstFormGroup.controls.rut.value + "-" + this.firstFormGroup.controls.dv.value;
    if (this.firstFormGroup.controls.rut.value.toString().includes(".")) {
      rutSinPuntos = this.firstFormGroup.controls.rut.value
        .toString()
        .replace(".", "");
      if (rutSinPuntos.includes(".")) {
        rutSinPuntos = rutSinPuntos.replace(".", "");
      }
      //console.log("entre en el if de los puntos", rutSinPuntos);
    }

    console.log("rutSinPuntos", rutSinPuntos)

    this.continuar = false;
    this._userService.traerInfo_rut(rutSinPuntos).subscribe(
      (response) => {
        this.firstFormGroup = this._formBuilder.group({
          rut: ["", [Validators.required]],
          dv: ["", [Validators.required]],
          mod_solicitante: this._formBuilder.group({
            nombre: ["", [Validators.required]],
            apellido_p: [""],
            apellido_m: [""],
            calle: ["", [Validators.required]],
            num: ["", [Validators.required]],
            complemento: [""],
            telefono: [""],
            cel: ["", [Validators.required]],
            ciudad: [""],
            comuna: [""],
            email: ["", [Validators.required, Validators.email]],
          }),
        });

        console.log("avu: ", response)

        this.rut_encontrado = false;
        if (response.status == true) {
          this.info_rut = response.data;
          this.rutSolicitante = this.info_rut.rut;

          var fullRut = this.rutSolicitante.split("-");

          //console.log("emit this.rutSolicitante", this.rutSolicitante)
          this.observableService.usuario$.emit(this.rutSolicitante);

          this.firstFormGroup = this._formBuilder.group({
            rut: [fullRut[0], [Validators.required]],
            dv: [fullRut[1], [Validators.required]],
            mod_solicitante: this._formBuilder.group({
              nombre: [this.info_rut.nombre, [Validators.required]],
              apellido_p: [this.info_rut.apellido_p],
              apellido_m: [this.info_rut.apellido_m],
              calle: [this.info_rut.calle, [Validators.required]],
              num: [this.info_rut.numero, [Validators.required]],
              complemento: [this.info_rut.complemento],
              telefono: [this.info_rut.telefono],
              cel: [this.info_rut.celular, [Validators.required]],
              ciudad: ["SI"],
              comuna: [this.info_rut.comuna],
              email: [this.info_rut.email, [Validators.required, Validators.email]],
            }),
          });




          this.emailValido = this.info_rut.emailValido;
          //console.log(this.info_rut, 'dataRut');
          this.observableService.correo$.emit(this.info_rut.email);

          //console.log(this.info_rut.email == "");
          //console.log(this.info_rut.email.length > 0);
          var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          if (re.test(String(this.info_rut.email).toLowerCase())) {
            this.continuar = true;
          }

          this.primerPaso = true;
          this.rut_encontrado = true;
          this._changeDetector.detectChanges();
        }
        if (response.status == false) {

          this.modificando = true;
          this.rut_encontrado = false;
          alert(response.message);
          this.firstFormGroup = this._formBuilder.group({
            rut: ["", [Validators.required]],
            dv: ["", [Validators.required]],
            mod_solicitante: this._formBuilder.group({
              nombre: ["", [Validators.required]],
              apellido_p: [""],
              apellido_m: [""],
              calle: ["", [Validators.required]],
              num: ["", [Validators.required]],
              complemento: [""],
              telefono: [""],
              cel: ["", [Validators.required]],
              ciudad: [""],
              comuna: [""],
              email: ["", [Validators.required, Validators.email]],
            }),
          });

        }
      },
      (error) => {
        console.log(error);
        this.modificando = true;
        this.rut_encontrado = false;

        /* swal({
            type: 'error',
            title: 'Ha ocurrido un error!',
            text: error._body,
            confirmButtonColor: '#3F51B5',
            confirmButtonText: 'Aceptar',
            timer: 3500
        }).then(() => {
        }, (dismiss) => {
            if (dismiss === 'timer') {
            }
        }); */
      }
    );
  }

  mod_inforut() {

    this.firstFormGroup.controls.mod_solicitante.setValue({
      nombre: this.info_rut.nombre ? this.info_rut.nombre : "",
      apellido_p: this.info_rut.apellido_p ? this.info_rut.apellido_p : " ",
      apellido_m: this.info_rut.apellido_m ? this.info_rut.apellido_m : " ",
      calle: this.info_rut.calle ? this.info_rut.calle : "",
      num: this.info_rut.numero ? this.info_rut.numero : " ",
      complemento: this.info_rut.complemento ? this.info_rut.complemento : " ",
      telefono: this.info_rut.telefono ? this.info_rut.telefono : " ",
      cel: this.info_rut.celular ? this.info_rut.celular : "",
      ciudad: this.info_rut.ciudad ? this.info_rut.ciudad : " ",
      comuna: this.info_rut.comuna ? this.info_rut.comuna : " ",
      email: this.info_rut.email ? this.info_rut.email : " ",
    });
    if (this.firstFormGroup.controls.mod_solicitante.value.nombre === '' || this.firstFormGroup.controls.mod_solicitante.value.cel === '' || this.firstFormGroup.controls.mod_solicitante.value.calle === '') {

      this.sig = false;

    }


    this.primerPaso_mod = true;
    this.primerPaso = false;
    this.modificando = true;
  }


  guarda_mod() {
    //console.log('form group', this.firstFormGroup);
    if (this.firstFormGroup.controls.mod_solicitante.value.nombre === '' || this.firstFormGroup.controls.mod_solicitante.value.cel === '' || this.firstFormGroup.controls.mod_solicitante.value.calle === '') {

      this.sig = false;
    }
    else { this.sig = true; }
    this._userService
      .save_info_mod_solicitante(
        this.info_rut.rut,
        this.firstFormGroup.controls.mod_solicitante.value
      )
      .subscribe(
        (response) => {
          //console.log(response);
          this.modificando = false;
          swal({
            type: "success",
            title: "Guardado!",
            text: response.message,
            confirmButtonColor: "#3F51B5",
            confirmButtonText: "Aceptar",
            timer: 3500,
          }).then(
            () => { },
            (dismiss) => {
              if (dismiss === "timer") {
              }
            }
          );
        },
        (error) => {
          console.log(error);
          swal({
            type: "error",
            title: "Ha ocurrido un error!",
            text: error._body,
            confirmButtonColor: "#3F51B5",
            confirmButtonText: "Aceptar",
            timer: 3500,
          }).then(
            () => { },
            (dismiss) => {
              if (dismiss === "timer") {
              }
            }
          );
        }
      );
  }


  cancelar_mod() {
    if (this.rut_encontrado) {
      this.modificando = false;
      this.primerPaso_mod = false;
      this.primerPaso = true;
    } else {
      this.modificando = false;
      this.rut_encontrado = false;
      this.primerPaso = false;
      this.primerPaso_mod = false;
    }
  }
  registro_sol() {
    var rutSinPuntos = this.firstFormGroup.controls.rut.value;
    if (this.firstFormGroup.controls.rut.value.toString().includes(".")) {
      rutSinPuntos = this.firstFormGroup.controls.rut.value
        .toString()
        .replace(".", "");
      if (rutSinPuntos.includes(".")) {
        rutSinPuntos = rutSinPuntos.replace(".", "");
      }
      //console.log("entre en el if de los puntos", rutSinPuntos);
    }


    this.rutSolicitante = this.info_rut.rut;
    var fullRut = this.rutSolicitante.split("-");

    var userinfo = {
      rut: fullRut[0],
      dv: fullRut[1],
      nombre: this.firstFormGroup.controls.mod_solicitante.value.nombre,
      app: this.firstFormGroup.controls.mod_solicitante.value.apellido_p,
      apm: this.firstFormGroup.controls.mod_solicitante.value.apellido_m,
      dir: this.firstFormGroup.controls.mod_solicitante.value.calle,
      num: this.firstFormGroup.controls.mod_solicitante.value.num,
      dircom: this.firstFormGroup.controls.mod_solicitante.value.complemento,
      telefono: this.firstFormGroup.controls.mod_solicitante.value.telefono,
      celular: this.firstFormGroup.controls.mod_solicitante.value.cel,
      ciudad: this.firstFormGroup.controls.mod_solicitante.value.ciudad,
      comuna: this.firstFormGroup.controls.mod_solicitante.value.comuna,
      email: this.firstFormGroup.controls.mod_solicitante.value.email,
    };
    this.firstFormGroup.controls.mod_solicitante.value.cel != ""
      ? (this.celularValido = true)
      : (this.celularValido = false);
    //console.log(this.celularValido);

    //console.log(userinfo);
    this._userService.save_solicitante(userinfo).subscribe(
      (response) => {
        //console.log(response);
        swal({
          type: "success",
          title: "Registrado!",
          text: response.message,
          confirmButtonColor: "#3F51B5",
          confirmButtonText: "Aceptar",
          timer: 3500,
        }).then(
          () => { },
          (dismiss) => {
            if (dismiss === "timer") {
            }
          }
        );
        this.buscar_info_sol();
        this.modificando = false;
      },
      (error) => {
        console.log(error);
        swal({
          type: "error",
          title: "Ha ocurrido un error!",
          text: error._body,
          confirmButtonColor: "#3F51B5",
          confirmButtonText: "Aceptar",
          timer: 3500,
        }).then(
          () => { },
          (dismiss) => {
            if (dismiss === "timer") {
            }
          }
        );
      }
    );
  }


  searchUser() {
    /* Buscar si existe en fm */
    let identityData = this._userService.getIdentity();
    let rut = identityData.rut + identityData.dv
    this._userService.buscarUsuario(rutClean(rut)).subscribe(
      response => {
        if (response.message) {
          this.spinner.hide();
          console.log(response);
         
        }
        if (response.register) {
          this.spinner.hide();
          console.log(response);

          this.dialog.open(RegistroComponent, {
            id: "logindialog",
            width: '50vw', // Ajusta el ancho
            height: 'auto', // Ajusta la altura
            disableClose: true // Evita cerrar al hacer clic fuera (opcional)
          });
        }

        if (response.update) {
          this.spinner.hide();
          console.log(response);

          this.dialog.open(RegistroComponent, {
            id: "logindialog",
            width: '50vw', // Ajusta el ancho
            height: 'auto', // Ajusta la altura
            disableClose: true // Evita cerrar al hacer clic fuera (opcional)
          });
        }

      },
      error => {
        let e = JSON.parse(error._body);
        this.spinner.hide();
      }
    )
  }

}
